import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles, Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles(theme => ({
  fileChip: {
    maxWidth: '50%',
    backgroundColor: theme.palette.facet.accentGreen,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.facet.accentGreen,
      color: theme.palette.common.white,
    },
    marginRight: theme.spacing(1),
  },
  multiChips: {
    marginBottom: theme.spacing(1),
  },
  selectedFile: {
    backgroundColor: theme.palette.facet.accentBlue,
    '&:hover': {
      backgroundColor: theme.palette.facet.accentBlue,
    },
  },
}));

export default function FileChips({
  fileCollection,
  handleDeleteFile,
  handleFileClick,
  fileExpand,
  setFileExpand,
  selectedFileId,
  setSelectedFileId,
  setAlternativeToggleDisplay,
  classOverride,
}) {
  const classes = useStyles();

  const fileCount = fileCollection
    ? fileCollection.resources().list().length
    : 0;

  if (fileCount === 0) {
    return null;
  }

  const fileChipStyleClass = classOverride || classes.fileChip;

  if (fileCount === 1) {
    return fileCollection
      .resources()
      .list()
      .map(r => (
        <Chip
          className={classNames({
            [fileChipStyleClass]: true,
            [classes.selectedFile]: selectedFileId === r.id(),
          })}
          component={Typography}
          noWrap
          key={`file.${r.id()}`}
          label={r.attr('name')}
          color="primary"
          onDelete={() => handleDeleteFile(r)}
          onClick={() => handleFileClick(r)}
          size="small"
        />
      ));
  }

  return fileExpand ? (
    <>
      {fileCollection
        .resources()
        .list()
        .map(r => (
          <Chip
            className={classNames({
              [fileChipStyleClass]: selectedFileId !== r.id(),
              [classes.multiChips]: true,
              [classes.selectedFile]: selectedFileId === r.id(),
            })}
            key={`file.${r.id()}`}
            label={r.attr('name')}
            component={Typography}
            noWrap
            color="primary"
            onDelete={() => handleDeleteFile(r)}
            onClick={() => handleFileClick(r)}
            size="small"
          />
        ))}
      <Chip
        className={classNames({
          [fileChipStyleClass]: true,
          [classes.multiChips]: true,
        })}
        label="Close files"
        color="primary"
        onClick={() => {
          setAlternativeToggleDisplay(false);
          setSelectedFileId('');
          setFileExpand(!fileExpand);
        }}
        size="small"
      />
    </>
  ) : (
    <Chip
      className={fileChipStyleClass}
      label={`${fileCount} files >`}
      color="primary"
      onClick={() => setFileExpand(!fileExpand)}
      size="small"
    />
  );
}

FileChips.propTypes = {
  fileCollection: PropTypes.object.isRequired,
  handleDeleteFile: PropTypes.func.isRequired,
  handleFileClick: PropTypes.func.isRequired,
  fileExpand: PropTypes.bool.isRequired,
  setFileExpand: PropTypes.func.isRequired,
  setAlternativeToggleDisplay: PropTypes.func.isRequired,
  setSelectedFileId: PropTypes.func.isRequired,
  selectedFileId: PropTypes.string,
  classOverride: PropTypes.string,
};

FileChips.defaultProps = {
  classOverride: undefined,
  selectedFileId: '',
};
